export const EbsBannerTexts = {
  heading: 'Будущее за биометрией — сдайте её заранее',
  description: 'Сможете получать финансовые услуги быстрее, безопаснее и без лишних действий. ',
  howToDo: 'Как сдать?',
};
